// extracted by mini-css-extract-plugin
export var actionText = "_pa-4";
export var container = "_pa-0";
export var leftSection = "_pa-1";
export var rightSection = "_pa-2";
export var settingsButton = "_pa-6";
export var settingsIcon = "_pa-7";
export var shortcut = "_pa-5";
export var shortcutGroup = "_pa-3";